// // // import { useState, useEffect, useCallback } from "react";
// // // import axiosClient from "../axiosClient";
// // // import {
// // //   BarChart,
// // //   Bar,
// // //   XAxis,
// // //   YAxis,
// // //   CartesianGrid,
// // //   Tooltip,
// // //   Legend,
// // //   ResponsiveContainer,
// // // } from "recharts";
// // // import { useStateContext } from "../context/ContextProvider";
// // // import { useTranslation } from "react-i18next";
// // // import {
// // //   Grid,
// // //   TextField,
// // //   Typography,
// // //   Box,
// // //   Divider,
// // //   Paper,
// // //   Button
// // // } from "@mui/material";

// // // const AssignedClientStats = () => {
// // //   const [data, setData] = useState([]);
// // //   const [missingData, setMissingData] = useState([]);
// // //   const [month, setMonth] = useState("");
// // //   const [year, setYear] = useState("");
// // //   const [week, setWeek] = useState("");
// // //   const [yearError, setYearError] = useState(""); // State for year validation error
// // //   const { user } = useStateContext();
// // //   const { t } = useTranslation();

// // //   // Helper function to get the Monday of the selected week
// // //   const getMondayOfWeek = (dateString) => {
// // //     const date = new Date(dateString);
// // //     const day = date.getDay(); // 0 (Sunday) to 6 (Saturday)
// // //     const diff = day === 0 ? -6 : -day + 1; // Adjust to previous Monday
// // //     date.setDate(date.getDate() + diff);
// // //     return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
// // //   };

// // //   const validateYear = useCallback((year) => {
// // //     if (!year) return true;
// // //     const yearNum = parseInt(year, 10);
// // //     if (isNaN(yearNum) || yearNum < 2000 || yearNum > 2100) {
// // //       setYearError(t("Year must be between 2000 and 2100"));
// // //       return false;
// // //     }
// // //     setYearError("");
// // //     return true;
// // //   }, [t]);

// // //   const fetchData = useCallback(
// // //     (url) => {
// // //       axiosClient
// // //         .get(url, {
// // //           headers: {
// // //             Authorization: `Bearer ${user.token}`,
// // //           },
// // //         })
// // //         .then((response) => {
// // //           if (response.data && Array.isArray(response.data)) {
// // //             setData(response.data);
// // //           } else {
// // //             console.error("Invalid data format:", response.data);
// // //             setData([]);
// // //           }
// // //         })
// // //         .catch((error) => {
// // //           console.error("Error fetching data:", error);
// // //           setData([]);
// // //         });
// // //     },
// // //     [user.token]
// // //   );

// // //   const fetchDataMissingAppointment = useCallback(
// // //     (url) => {
// // //       axiosClient
// // //         .get(url, {
// // //           headers: {
// // //             Authorization: `Bearer ${user.token}`,
// // //           },
// // //         })
// // //         .then((response) => {
// // //           if (response.data && Array.isArray(response.data)) {
// // //             setMissingData(response.data);
// // //           } else {
// // //             console.error("Invalid data format:", response.data);
// // //             setMissingData([]);
// // //           }
// // //         })
// // //         .catch((error) => {
// // //           console.error("Error fetching data:", error);
// // //           setMissingData([]);
// // //         });
// // //     },
// // //     [user.token]
// // //   );

// // //   useEffect(() => {
// // //     if (month) {
// // //       const [year, mon] = month.split("-");
// // //       fetchData(`api/assignedClientStats/month/${mon}-${year}/`);
// // //       fetchDataMissingAppointment(`api/missing-appointment/month/${mon}-${year}/`);
// // //     }
// // //   }, [month, fetchData, fetchDataMissingAppointment]);

// // //   useEffect(() => {
// // //     if (year && validateYear(year)) {
// // //       fetchData(`api/assignedClientStats/year/${year}/`);
// // //       fetchDataMissingAppointment(`api/missing-appointment/year/${year}/`);
// // //     }
// // //   }, [year, fetchData, fetchDataMissingAppointment, validateYear]);

// // //   useEffect(() => {
// // //     if (week) {
// // //       fetchData(`api/assignedClientStats/week/${week}/`);
// // //       fetchDataMissingAppointment(`api/missing-appointment/week/${week}/`);
// // //     }
// // //   }, [week, fetchData, fetchDataMissingAppointment]);

// // //   const handleMonthChange = (e) => {
// // //     setMonth(e.target.value);
// // //     setYear("");
// // //     setWeek("");
// // //   };

// // //   const handleYearChange = (e) => {
// // //     const value = e.target.value;
// // //     setYear(value);
// // //     setMonth("");
// // //     setWeek("");
// // //     validateYear(value);
// // //   };

// // //   const handleWeekChange = (e) => {
// // //     const selectedDate = e.target.value;
// // //     if (selectedDate) {
// // //       const mondayDate = getMondayOfWeek(selectedDate);
// // //       setWeek(mondayDate);
// // //     } else {
// // //       setWeek("");
// // //     }
// // //     setMonth("");
// // //     setYear("");
// // //   };

// // //   // Clear all filters
// // //   const handleClearFilters = () => {
// // //     setMonth("");
// // //     setYear("");
// // //     setWeek("");
// // //     setYearError("");
// // //     setData([]);
// // //     setMissingData([]);
// // //   };

// // //   return (
// // //     <Box sx={{ p: { xs: 2, md: 4 } }}>
// // //       {/* Inform users about Monday requirement */}
// // //       <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
// // //         {t(
// // //           "Note: For weekly stats, please select a Monday. The system will automatically adjust to the Monday of the selected week."
// // //         )}
// // //       </Typography>

// // //       {/* Input Fields */}
// // //       <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
// // //         <Grid container spacing={3}>
// // //           <Grid item xs={12} md={4}>
// // //             <Typography variant="h6" gutterBottom>
// // //               {t("Assigned Patient Stats by Week")}
// // //             </Typography>
// // //             <TextField
// // //               type="date"
// // //               value={week}
// // //               onChange={handleWeekChange}
// // //               fullWidth
// // //               variant="outlined"
// // //               InputLabelProps={{ shrink: true }}
// // //             />
// // //           </Grid>
// // //           <Grid item xs={12} md={4}>
// // //             <Typography variant="h6" gutterBottom>
// // //               {t("Assigned Patient Stats by Month")}
// // //             </Typography>
// // //             <TextField
// // //               type="month"
// // //               value={month}
// // //               onChange={handleMonthChange}
// // //               fullWidth
// // //               variant="outlined"
// // //               InputLabelProps={{ shrink: true }}
// // //             />
// // //           </Grid>
// // //           <Grid item xs={12} md={4}>
// // //             <Typography variant="h6" gutterBottom>
// // //               {t("Assigned Patient Stats by Year")}
// // //             </Typography>
// // //             <TextField
// // //               type="number"
// // //               value={year}
// // //               onChange={handleYearChange}
// // //               fullWidth
// // //               variant="outlined"
// // //               InputProps={{
// // //                 inputProps: { min: 2000, max: 2100 },
// // //               }}
// // //               InputLabelProps={{ shrink: true }}
// // //               error={!!yearError}
// // //               helperText={yearError}
// // //             />
// // //           </Grid>
// // //           <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
// // //             <Button
// // //               variant="outlined"
// // //               color="secondary"
// // //               onClick={handleClearFilters}
// // //               sx={{ mt: 2 }}
// // //             >
// // //               {t("Clear Filters")}
// // //             </Button>
// // //           </Grid>
// // //         </Grid>
// // //       </Paper>

// // //       {/* Assigned Client Stats Chart */}
// // //       <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
// // //         {data.length > 0 ? (
// // //           <ResponsiveContainer width="100%" height={400}>
// // //             <BarChart
// // //               data={data}
// // //               margin={{
// // //                 top: 5,
// // //                 right: 30,
// // //                 left: 20,
// // //                 bottom: 5,
// // //               }}
// // //             >
// // //               <CartesianGrid strokeDasharray="3 3" />
// // //               <XAxis
// // //                 dataKey="name"
// // //                 label={{
// // //                   value: "Staff Name",
// // //                   position: "insideBottomRight",
// // //                   offset: -5,
// // //                 }}
// // //               />
// // //               <YAxis
// // //                 label={{ value: "Total", angle: -90, position: "insideLeft" }}
// // //               />
// // //               <Tooltip />
// // //               <Legend />
// // //               <Bar dataKey="total" fill="#8884d8" barSize={50} />
// // //             </BarChart>
// // //           </ResponsiveContainer>
// // //         ) : (
// // //           <Typography>{t("No data available for the selected period")}.</Typography>
// // //         )}
// // //       </Paper>

// // //       {/* Missing Appointment Chart */}
// // //       <Paper elevation={3} sx={{ p: 3 }}>
// // //         <Divider sx={{ my: 2 }} />
// // //         <Typography variant="h6" gutterBottom>
// // //           {t("Missing Appointment by Patients")}
// // //         </Typography>
// // //         {missingData.length > 0 ? (
// // //           <ResponsiveContainer width="100%" height={400}>
// // //             <BarChart
// // //               data={missingData}
// // //               margin={{
// // //                 top: 5,
// // //                 right: 30,
// // //                 left: 20,
// // //                 bottom: 5,
// // //               }}
// // //             >
// // //               <CartesianGrid strokeDasharray="3 3" />
// // //               <XAxis
// // //                 dataKey="name"
// // //                 label={{
// // //                   value: "Staff Name",
// // //                   position: "insideBottomRight",
// // //                   offset: -5,
// // //                 }}
// // //               />
// // //               <YAxis
// // //                 label={{ value: "Total", angle: -90, position: "insideLeft" }}
// // //               />
// // //               <Tooltip />
// // //               <Legend />
// // //               <Bar dataKey="total" fill="#8884d8" barSize={50} />
// // //             </BarChart>
// // //           </ResponsiveContainer>
// // //         ) : (
// // //           <Typography>
// // //             {t("No Missing Appointment data available for the selected period")}.
// // //           </Typography>
// // //         )}
// // //       </Paper>
// // //     </Box>
// // //   );
// // // };

// // // export default AssignedClientStats;


// // import { useState, useEffect, useCallback } from "react";
// // import axiosClient from "../axiosClient";
// // import {
// //   BarChart,
// //   Bar,
// //   XAxis,
// //   YAxis,
// //   CartesianGrid,
// //   Tooltip,
// //   Legend,
// //   ResponsiveContainer,
// // } from "recharts";
// // import { useStateContext } from "../context/ContextProvider";
// // import { useTranslation } from "react-i18next";
// // import {
// //   Grid,
// //   TextField,
// //   Typography,
// //   Box,
// //   Divider,
// //   Paper,
// //   Button,
// // } from "@mui/material";

// // const AssignedClientStats = () => {
// //   const [data, setData] = useState([]);
// //   const [missingData, setMissingData] = useState([]);
// //   const [month, setMonth] = useState("");
// //   const [year, setYear] = useState("");
// //   const [week, setWeek] = useState("");
// //   const [yearError, setYearError] = useState("");
// //   const { user } = useStateContext();
// //   const { t } = useTranslation();

// //   const getMondayOfWeek = (dateString) => {
// //     const date = new Date(dateString);
// //     const day = date.getDay();
// //     const diff = day === 0 ? -6 : -day + 1;
// //     date.setDate(date.getDate() + diff);
// //     return date.toISOString().split("T")[0];
// //   };

// //   const validateYear = useCallback(
// //     (year) => {
// //       if (!year) return true;
// //       const yearNum = parseInt(year, 10);
// //       if (isNaN(yearNum) || yearNum < 2000 || yearNum > 2100) {
// //         setYearError(t("reports.yearValidationError"));
// //         return false;
// //       }
// //       setYearError("");
// //       return true;
// //     },
// //     [t]
// //   );

// //   const { token } = user;

// //   const fetchData = useCallback(
// //     (url) => {
// //       axiosClient
// //         .get(url, {
// //           headers: {
// //             Authorization: `Bearer ${token}`,
// //           },
// //         })
// //         .then((response) => {
// //           if (response.data && Array.isArray(response.data)) {
// //             setData(response.data);
// //           } else {
// //             console.error("Invalid data format:", response.data);
// //             setData([]);
// //           }
// //         })
// //         .catch((error) => {
// //           console.error("Error fetching data:", error);
// //           setData([]);
// //         });
// //     },
// //     [token]
// //   );

// //   const fetchDataMissingAppointment = useCallback(
// //     (url) => {
// //       axiosClient
// //         .get(url, {
// //           headers: {
// //             Authorization: `Bearer ${token}`,
// //           },
// //         })
// //         .then((response) => {
// //           if (response.data && Array.isArray(response.data)) {
// //             setMissingData(response.data);
// //           } else {
// //             console.error("Invalid data format:", response.data);
// //             setMissingData([]);
// //           }
// //         })
// //         .catch((error) => {
// //           console.error("Error fetching data:", error);
// //           setMissingData([]);
// //         });
// //     },
// //     [token]
// //   );

// //   useEffect(() => {
// //     if (month) {
// //       const [year, mon] = month.split("-");
// //       fetchData(`api/assignedClientStats/month/${mon}-${year}/`);
// //       fetchDataMissingAppointment(
// //         `api/missing-appointment/month/${mon}-${year}/`
// //       );
// //     }
// //   }, [month, fetchData, fetchDataMissingAppointment]);

// //   useEffect(() => {
// //     if (year && validateYear(year)) {
// //       fetchData(`api/assignedClientStats/year/${year}/`);
// //       fetchDataMissingAppointment(`api/missing-appointment/year/${year}/`);
// //     }
// //   }, [year, fetchData, fetchDataMissingAppointment, validateYear]);

// //   useEffect(() => {
// //     if (week) {
// //       fetchData(`api/assignedClientStats/week/${week}/`);
// //       fetchDataMissingAppointment(`api/missing-appointment/week/${week}/`);
// //     }
// //   }, [week, fetchData, fetchDataMissingAppointment]);

// //   const handleMonthChange = (e) => {
// //     setMonth(e.target.value);
// //     setYear("");
// //     setWeek("");
// //   };

// //   const handleYearChange = (e) => {
// //     const value = e.target.value;
// //     setYear(value);
// //     setMonth("");
// //     setWeek("");
// //     validateYear(value);
// //   };

// //   const handleWeekChange = (e) => {
// //     const selectedDate = e.target.value;
// //     if (selectedDate) {
// //       const mondayDate = getMondayOfWeek(selectedDate);
// //       setWeek(mondayDate);
// //     } else {
// //       setWeek("");
// //     }
// //     setMonth("");
// //     setYear("");
// //   };

// //   const handleClearFilters = () => {
// //     setMonth("");
// //     setYear("");
// //     setWeek("");
// //     setYearError("");
// //     setData([]);
// //     setMissingData([]);
// //   };

// //   return (
// //     <Box sx={{ p: { xs: 2, md: 4 } }}>
// //       {/* Note for weekly stats */}
// //       <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
// //         {t("reports.weekNote")}
// //       </Typography>

// //       {/* Filters */}
// //       <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
// //         <Grid container spacing={3}>
// //           <Grid item xs={12} md={4}>
// //             <Typography variant="h6" gutterBottom>
// //               {t("reports.statsByWeek")}
// //             </Typography>
// //             <TextField
// //               type="date"
// //               value={week}
// //               onChange={handleWeekChange}
// //               fullWidth
// //               variant="outlined"
// //               InputLabelProps={{ shrink: true }}
// //             />
// //           </Grid>
// //           <Grid item xs={12} md={4}>
// //             <Typography variant="h6" gutterBottom>
// //               {t("reports.statsByMonth")}
// //             </Typography>
// //             <TextField
// //               type="month"
// //               value={month}
// //               onChange={handleMonthChange}
// //               fullWidth
// //               variant="outlined"
// //               InputLabelProps={{ shrink: true }}
// //             />
// //           </Grid>
// //           <Grid item xs={12} md={4}>
// //             <Typography variant="h6" gutterBottom>
// //               {t("reports.statsByYear")}
// //             </Typography>
// //             <TextField
// //               type="number"
// //               value={year}
// //               onChange={handleYearChange}
// //               fullWidth
// //               variant="outlined"
// //               InputProps={{
// //                 inputProps: { min: 2000, max: 2100 },
// //               }}
// //               InputLabelProps={{ shrink: true }}
// //               error={!!yearError}
// //               helperText={yearError}
// //             />
// //           </Grid>
// //           <Grid
// //             item
// //             xs={12}
// //             sx={{ display: "flex", justifyContent: "flex-end" }}
// //           >
// //             <Button
// //               variant="outlined"
// //               color="secondary"
// //               onClick={handleClearFilters}
// //               sx={{ mt: 2 }}
// //             >
// //               {t("Clear Filters")}
// //             </Button>
// //           </Grid>
// //         </Grid>
// //       </Paper>

// //       {/* Assigned Client Stats Chart */}
// //       <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
// //         {data.length > 0 ? (
// //           <ResponsiveContainer width="100%" height={400}>
// //             <BarChart
// //               data={data}
// //               margin={{
// //                 top: 5,
// //                 right: 30,
// //                 left: 20,
// //                 bottom: 5,
// //               }}
// //             >
// //               <CartesianGrid strokeDasharray="3 3" />
// //               <XAxis
// //                 dataKey="name"
// //                 label={{
// //                   value: t("assignedStats.staffName"),
// //                   position: "insideBottomRight",
// //                   offset: -5,
// //                 }}
// //               />
// //               <YAxis
// //                 label={{
// //                   value: t("assignedStats.total"),
// //                   angle: -90,
// //                   position: "insideLeft",
// //                 }}
// //               />
// //               <Tooltip />
// //               <Legend />
// //               <Bar dataKey="total" fill="#8884d8" barSize={50} />
// //             </BarChart>
// //           </ResponsiveContainer>
// //         ) : (
// //           <Typography>{t("reports.noDataForPeriod")}</Typography>
// //         )}
// //       </Paper>

// //       {/* Missing Appointment Chart */}
// //       <Paper elevation={3} sx={{ p: 3 }}>
// //         <Divider sx={{ my: 2 }} />
// //         <Typography variant="h6" gutterBottom>
// //           {t("assignedStats.missingTitle")}
// //         </Typography>
// //         {missingData.length > 0 ? (
// //           <ResponsiveContainer width="100%" height={400}>
// //             <BarChart
// //               data={missingData}
// //               margin={{
// //                 top: 5,
// //                 right: 30,
// //                 left: 20,
// //                 bottom: 5,
// //               }}
// //             >
// //               <CartesianGrid strokeDasharray="3 3" />
// //               <XAxis
// //                 dataKey="name"
// //                 label={{
// //                   value: t("assignedStats.staffName"),
// //                   position: "insideBottomRight",
// //                   offset: -5,
// //                 }}
// //               />
// //               <YAxis
// //                 label={{
// //                   value: t("assignedStats.total"),
// //                   angle: -90,
// //                   position: "insideLeft",
// //                 }}
// //               />
// //               <Tooltip />
// //               <Legend />
// //               <Bar dataKey="total" fill="#8884d8" barSize={50} />
// //             </BarChart>
// //           </ResponsiveContainer>
// //         ) : (
// //           <Typography>
// //             {t("assignedStats.noMissingData")}
// //           </Typography>
// //         )}
// //       </Paper>
// //     </Box>
// //   );
// // };

// // export default AssignedClientStats;



// import { useState, useEffect, useCallback } from "react";
// import axiosClient from "../axiosClient";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
// } from "recharts";
// import { useStateContext } from "../context/ContextProvider";
// import { useTranslation } from "react-i18next";
// import {
//   Grid,
//   TextField,
//   Typography,
//   Box,
//   Divider,
//   Paper,
//   Button,
// } from "@mui/material";

// const AssignedClientStats = () => {
//   const [data, setData] = useState([]);
//   const [missingData, setMissingData] = useState([]);
//   const [month, setMonth] = useState("");
//   const [year, setYear] = useState("");
//   const [week, setWeek] = useState("");
//   const [yearError, setYearError] = useState("");
//   const { user } = useStateContext();
//   const { t } = useTranslation();

//   const getMondayOfWeek = (dateString) => {
//     const date = new Date(dateString);
//     const day = date.getDay();
//     const diff = day === 0 ? -6 : -day + 1;
//     date.setDate(date.getDate() + diff);
//     return date.toISOString().split("T")[0];
//   };

//   const validateYear = useCallback(
//     (year) => {
//       if (!year) return true;
//       const yearNum = parseInt(year, 10);
//       if (isNaN(yearNum) || yearNum < 2000 || yearNum > 2100) {
//         setYearError(t("reports.yearValidationError"));
//         return false;
//       }
//       setYearError("");
//       return true;
//     },
//     [t]
//   );

//   const { token } = user;

//   const fetchData = useCallback(
//     (url) => {
//       axiosClient
//         .get(url, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         })
//         .then((response) => {
//           if (response.data && Array.isArray(response.data)) {
//             setData(response.data);
//           } else {
//             console.error("Invalid data format:", response.data);
//             setData([]);
//           }
//         })
//         .catch((error) => {
//           console.error("Error fetching data:", error);
//           setData([]);
//         });
//     },
//     [token]
//   );

//   const fetchDataMissingAppointment = useCallback(
//     (url) => {
//       axiosClient
//         .get(url, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         })
//         .then((response) => {
//           if (response.data && Array.isArray(response.data)) {
//             setMissingData(response.data);
//           } else {
//             console.error("Invalid data format:", response.data);
//             setMissingData([]);
//           }
//         })
//         .catch((error) => {
//           console.error("Error fetching data:", error);
//           setMissingData([]);
//         });
//     },
//     [token]
//   );

//   useEffect(() => {
//     if (month) {
//       const [year, mon] = month.split("-");
//       fetchData(`api/assignedClientStats/month/${mon}-${year}/`);
//       fetchDataMissingAppointment(
//         `api/missing-appointment/month/${mon}-${year}/`
//       );
//     }
//   }, [month, fetchData, fetchDataMissingAppointment]);

//   useEffect(() => {
//     if (year && validateYear(year)) {
//       fetchData(`api/assignedClientStats/year/${year}/`);
//       fetchDataMissingAppointment(`api/missing-appointment/year/${year}/`);
//     }
//   }, [year, fetchData, fetchDataMissingAppointment, validateYear]);

//   useEffect(() => {
//     if (week) {
//       fetchData(`api/assignedClientStats/week/${week}/`);
//       fetchDataMissingAppointment(`api/missing-appointment/week/${week}/`);
//     }
//   }, [week, fetchData, fetchDataMissingAppointment]);

//   const handleMonthChange = (e) => {
//     setMonth(e.target.value);
//     setYear("");
//     setWeek("");
//   };

//   const handleYearChange = (e) => {
//     const value = e.target.value;
//     setYear(value);
//     setMonth("");
//     setWeek("");
//     validateYear(value);
//   };

//   const handleWeekChange = (e) => {
//     const selectedDate = e.target.value;
//     if (selectedDate) {
//       const mondayDate = getMondayOfWeek(selectedDate);
//       setWeek(mondayDate);
//     } else {
//       setWeek("");
//     }
//     setMonth("");
//     setYear("");
//   };

//   const handleClearFilters = () => {
//     setMonth("");
//     setYear("");
//     setWeek("");
//     setYearError("");
//     setData([]);
//     setMissingData([]);
//   };

//   return (
//     <Box sx={{ p: { xs: 2, md: 4 } }}>
//       {/* Hello Message */}
//       <Typography variant="h4" sx={{ mb: 2, fontWeight: 'bold', color: 'primary.main' }}>
//         {t("Hello")}, {user?.first_name || "Admin"}!
//       </Typography>

//       {/* Note for weekly stats */}
//       <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//         {t("reports.weekNote")}
//       </Typography>

//       {/* Filters */}
//       <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom color="primary">
//               {t("Issues statistics per Room per week")}
//             </Typography>
//             <TextField
//               type="date"
//               value={week}
//               onChange={handleWeekChange}
//               fullWidth
//               variant="outlined"
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom color="primary">
//               {t("Issues statistics per Room per month")}
//             </Typography>
//             <TextField
//               type="month"
//               value={month}
//               onChange={handleMonthChange}
//               fullWidth
//               variant="outlined"
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom color="primary">
//               {t("Appointment statistics per Room per year")}
//             </Typography>
//             <TextField
//               type="number"
//               value={year}
//               onChange={handleYearChange}
//               fullWidth
//               variant="outlined"
//               InputProps={{
//                 inputProps: { min: 2000, max: 2100 },
//               }}
//               InputLabelProps={{ shrink: true }}
//               error={!!yearError}
//               helperText={yearError}
//             />
//           </Grid>
//           <Grid
//             item
//             xs={12}
//             sx={{ display: "flex", justifyContent: "flex-end" }}
//           >
//             <Button
//               variant="outlined"
//               color="secondary"
//               onClick={handleClearFilters}
//               sx={{ mt: 2 }}
//             >
//               {t("Clear Filters")}
//             </Button>
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Assigned Client Stats Chart */}
//       <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
//         {data.length > 0 ? (
//           <ResponsiveContainer width="100%" height={400}>
//             <BarChart
//               data={data}
//               margin={{
//                 top: 5,
//                 right: 30,
//                 left: 20,
//                 bottom: 25,
//               }}
//             >
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis
//                 dataKey="name"
//                 label={{
//                   value: t("Room Number"),
//                   position: "insideBottom",
//                   offset: -10,
//                 }}
//               />
//               <YAxis
//                 label={{
//                   value: t("assignedStats.total"),
//                   angle: -90,
//                   position: "insideLeft",
//                 }}
//               />
//               <Tooltip />
//               <Legend verticalAlign="top" height={36}/>
//               <Bar dataKey="total" fill="#8884d8" name={t("Issues")} barSize={50} />
//             </BarChart>
//           </ResponsiveContainer>
//         ) : (
//           <Box sx={{ py: 10, textAlign: 'center' }}>
//             <Typography>{t("reports.noDataForPeriod")}</Typography>
//           </Box>
//         )}
//       </Paper>

//       {/* Missing Appointment Chart */}
//       <Paper elevation={3} sx={{ p: 3 }}>
//         <Divider sx={{ my: 2 }} />
//         <Typography variant="h6" gutterBottom color="error">
//           {t("Missing Appointment per Room")}
//         </Typography>
//         {missingData.length > 0 ? (
//           <ResponsiveContainer width="100%" height={400}>
//             <BarChart
//               data={missingData}
//               margin={{
//                 top: 5,
//                 right: 30,
//                 left: 20,
//                 bottom: 25,
//               }}
//             >
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis
//                 dataKey="name"
//                 label={{
//                   value: t("Room Number"),
//                   position: "insideBottom",
//                   offset: -10,
//                 }}
//               />
//               <YAxis
//                 label={{
//                   value: t("assignedStats.total"),
//                   angle: -90,
//                   position: "insideLeft",
//                 }}
//               />
//               <Tooltip />
//               <Legend verticalAlign="top" height={36}/>
//               <Bar dataKey="total" fill="#ff7043" name={t("Missing")} barSize={50} />
//             </BarChart>
//           </ResponsiveContainer>
//         ) : (
//           <Box sx={{ py: 5, textAlign: 'center' }}>
//             <Typography>
//               {t("assignedStats.noMissingData")}
//             </Typography>
//           </Box>
//         )}
//       </Paper>
//     </Box>
//   );
// };

// export default AssignedClientStats;

/////////////////////////////////////////////////////

// import { useState, useEffect, useCallback } from "react";
// import axiosClient from "../axiosClient";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
// } from "recharts";
// import { useStateContext } from "../context/ContextProvider";
// import { useTranslation } from "react-i18next";
// import {
//   Grid,
//   TextField,
//   Typography,
//   Box,
//   Paper,
//   Button,
// } from "@mui/material";

// const AssignedClientStats = () => {
//   const [data, setData] = useState([]);
//   const [month, setMonth] = useState("");
//   const [year, setYear] = useState("");
//   const [week, setWeek] = useState("");
//   const [yearError, setYearError] = useState("");
//   const { user } = useStateContext();
//   const { t } = useTranslation();

//   const getMondayOfWeek = (dateString) => {
//     const date = new Date(dateString);
//     const day = date.getDay();
//     const diff = day === 0 ? -6 : -day + 1;
//     date.setDate(date.getDate() + diff);
//     return date.toISOString().split("T")[0];
//   };

//   const validateYear = useCallback(
//     (year) => {
//       if (!year) return true;
//       const yearNum = parseInt(year, 10);
//       if (isNaN(yearNum) || yearNum < 2000 || yearNum > 2100) {
//         setYearError(t("reports.yearValidationError"));
//         return false;
//       }
//       setYearError("");
//       return true;
//     },
//     [t]
//   );

//   const { token } = user;

//   const fetchData = useCallback(
//     (url) => {
//       axiosClient
//         .get(url, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         })
//         .then((response) => {
//           if (response.data && Array.isArray(response.data)) {
//             setData(response.data);
//           } else {
//             console.error("Invalid data format:", response.data);
//             setData([]);
//           }
//         })
//         .catch((error) => {
//           console.error("Error fetching data:", error);
//           setData([]);
//         });
//     },
//     [token]
//   );

//   useEffect(() => {
//     if (month) {
//       const [year, mon] = month.split("-");
//       // fetchData(`api/assignedClientStats/month/${mon}-${year}/`);
//       fetchData('assignedClientStats/month/${mon}-${year}/');
      
//     }
//   }, [month, fetchData]);

//   useEffect(() => {
//     if (year && validateYear(year)) {
//       // fetchData(`api/assignedClientStats/year/${year}/`);
//       // fetchData('assignedClientStats/year/${year}/');
//     // ✅ CHANGE: Use backticks ``
//       fetchData(`assignedClientStats/year/${year}/`);  
//     }
//   }, [year, fetchData, validateYear]);

//   useEffect(() => {
//     if (week) {
//       // fetchData(`api/assignedClientStats/week/${week}/`);
//       fetchData('assignedClientStats/week/${week}/');
//     }
//   }, [week, fetchData]);

//   const handleMonthChange = (e) => {
//     setMonth(e.target.value);
//     setYear("");
//     setWeek("");
//   };

//   const handleYearChange = (e) => {
//     const value = e.target.value;
//     setYear(value);
//     setMonth("");
//     setWeek("");
//     validateYear(value);
//   };

//   const handleWeekChange = (e) => {
//     const selectedDate = e.target.value;
//     if (selectedDate) {
//       const mondayDate = getMondayOfWeek(selectedDate);
//       setWeek(mondayDate);
//     } else {
//       setWeek("");
//     }
//     setMonth("");
//     setYear("");
//   };

//   const handleClearFilters = () => {
//     setMonth("");
//     setYear("");
//     setWeek("");
//     setYearError("");
//     setData([]);
//   };

//   return (
//     <Box sx={{ p: { xs: 2, md: 4 } }}>
//       {/* Hello Message */}
//       {/* <Typography variant="h4" sx={{ mb: 2, fontWeight: 'bold', color: 'primary.main' }}>
//         {t("Hello")}, {user?.first_name || "Admin"}!
//       </Typography> */}

//       {/* Note for weekly stats */}
//       <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//         {t("reports.weekNote")}
//       </Typography>

//       {/* Filters */}
//       <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom color="primary">
//               {t("Issues statistics per Room per week")}
//             </Typography>
//             <TextField
//               type="date"
//               value={week}
//               onChange={handleWeekChange}
//               fullWidth
//               variant="outlined"
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom color="primary">
//               {t("Issues statistics per Room per month")}
//             </Typography>
//             <TextField
//               type="month"
//               value={month}
//               onChange={handleMonthChange}
//               fullWidth
//               variant="outlined"
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom color="primary">
//               {t("Appointment statistics per Room per year")}
//             </Typography>
//             <TextField
//               type="number"
//               value={year}
//               onChange={handleYearChange}
//               fullWidth
//               variant="outlined"
//               InputProps={{
//                 inputProps: { min: 2000, max: 2100 },
//               }}
//               InputLabelProps={{ shrink: true }}
//               error={!!yearError}
//               helperText={yearError}
//             />
//           </Grid>
//           <Grid
//             item
//             xs={12}
//             sx={{ display: "flex", justifyContent: "flex-end" }}
//           >
//             <Button
//               variant="outlined"
//               color="secondary"
//               onClick={handleClearFilters}
//               sx={{ mt: 2 }}
//             >
//               {t("Clear Filters")}
//             </Button>
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Issues Stats Chart */}
//       <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
//         {data.length > 0 ? (
//           <ResponsiveContainer width="100%" height={400}>
//             <BarChart
//               data={data}
//               margin={{
//                 top: 5,
//                 right: 30,
//                 left: 20,
//                 bottom: 25,
//               }}
//             >
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis
//                 dataKey="name"
//                 label={{
//                   value: t("Room Number"),
//                   position: "insideBottom",
//                   offset: -10,
//                 }}
//               />
//               <YAxis
//                 label={{
//                   value: t("assignedStats.total"),
//                   angle: -90,
//                   position: "insideLeft",
//                 }}
//               />
//               <Tooltip />
//               <Legend verticalAlign="top" height={36}/>
//               <Bar dataKey="total" fill="#8884d8" name={t("Issues")} barSize={50} />
//             </BarChart>
//           </ResponsiveContainer>
//         ) : (
//           <Box sx={{ py: 10, textAlign: 'center' }}>
//             <Typography>{t("reports.noDataForPeriod")}</Typography>
//           </Box>
//         )}
//       </Paper>
//     </Box>
//   );
// };

// export default AssignedClientStats;


/////////////////////////////////


// import { useState, useEffect, useCallback } from "react";
// import axiosClient from "../axiosClient";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
// } from "recharts";
// import { useStateContext } from "../context/ContextProvider";
// import { useTranslation } from "react-i18next";
// import {
//   Grid,
//   TextField,
//   Typography,
//   Box,
//   Paper,
//   Button,
// } from "@mui/material";

// const AssignedClientStats = () => {
//   const [data, setData] = useState([]);
//   const [month, setMonth] = useState("");
//   const [year, setYear] = useState("");
//   const [week, setWeek] = useState("");
//   const [yearError, setYearError] = useState("");
//   const { user } = useStateContext();
//   const { t } = useTranslation();

//   const getMondayOfWeek = (dateString) => {
//     const date = new Date(dateString);
//     const day = date.getDay();
//     const diff = day === 0 ? -6 : -day + 1;
//     date.setDate(date.getDate() + diff);
//     return date.toISOString().split("T")[0];
//   };

//   const validateYear = useCallback(
//     (year) => {
//       if (!year) return true;
//       const yearNum = parseInt(year, 10);
//       if (isNaN(yearNum) || yearNum < 2000 || yearNum > 2100) {
//         setYearError(t("reports.yearValidationError"));
//         return false;
//       }
//       setYearError("");
//       return true;
//     },
//     [t]
//   );

//   const { token } = user;

//   // const fetchData = useCallback(
//   //   (url) => {
//   //     axiosClient
//   //       .get(url, {
//   //         headers: {
//   //           Authorization: `Bearer ${token}`,
//   //         },
//   //       })
//   //       .then((response) => {
//   //         // ✅ Reset data to empty array if no results found to trigger "No Data" UI
//   //         if (response.data && Array.isArray(response.data) && response.data.length > 0) {
//   //           setData(response.data);
//   //         } else {
//   //           setData([]);
//   //         }
//   //       })
//   //       .catch((error) => {
//   //         console.error("Error fetching data:", error);
//   //         setData([]);
//   //       });
//   //   },
//   //   [token]
//   // );

//   const fetchData = useCallback(
//     (url) => {
//       // 1. Clear data immediately when a new request starts
//       // This ensures the old graph disappears while loading
//       setData([]); 

//       axiosClient
//         .get(url, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         })
//         .then((response) => {
//           // 2. Only set data if the array actually has items
//           if (response.data && Array.isArray(response.data) && response.data.length > 0) {
//             setData(response.data);
//           } else {
//             // 3. If API returns [], the graph stays empty
//             setData([]);
//           }
//         })
//         .catch((error) => {
//           console.error("Error fetching data:", error);
//           setData([]); // Clear on error
//         });
//     },
//     [token]
//   );

//   useEffect(() => {
//     if (month) {
//       // month value from <TextField type="month"> is "YYYY-MM" (e.g., "2026-04")
//       const [y, mon] = month.split("-");
      
//       // ✅ Check your Django URL pattern. 
//       // If your backend expects "4-2026", use mon.replace(/^0+/, '')
//       // If your backend expects "04-2026", use mon (as is)
//       const formattedMonth = `${mon}-${y}`; 
      
//       console.log("Fetching Month Stats for:", formattedMonth);
//       fetchData(`assignedClientStats/month/${formattedMonth}/`);
//     }
//   }, [month, fetchData]);

  
//   useEffect(() => {
//     if (month) {
//       const [y, mon] = month.split("-");
//       fetchData(`assignedClientStats/month/${mon}-${y}/`);
//     }
//   }, [month, fetchData]);

//   useEffect(() => {
//     if (year && validateYear(year)) {
//       fetchData(`assignedClientStats/year/${year}/`);
//     }
//   }, [year, fetchData, validateYear]);

//   useEffect(() => {
//     if (week) {
//       fetchData(`assignedClientStats/week/${week}/`);
//     }
//   }, [week, fetchData]);

//   const handleMonthChange = (e) => {
//     setData([]); // ✅ Clear old graph immediately
//     setMonth(e.target.value);
//     setYear("");
//     setWeek("");
//   };

//   const handleYearChange = (e) => {
//     const value = e.target.value;
//     setData([]); // ✅ Clear old graph immediately
//     setYear(value);
//     setMonth("");
//     setWeek("");
//     validateYear(value);
//   };

//   const handleWeekChange = (e) => {
//     const selectedDate = e.target.value;
//     setData([]); // ✅ Clear old graph immediately
//     if (selectedDate) {
//       const mondayDate = getMondayOfWeek(selectedDate);
//       setWeek(mondayDate);
//     } else {
//       setWeek("");
//     }
//     setMonth("");
//     setYear("");
//   };

//   const handleClearFilters = () => {
//     setMonth("");
//     setYear("");
//     setWeek("");
//     setYearError("");
//     setData([]);
//   };

//   return (
//     <Box sx={{ p: { xs: 2, md: 4 } }}>
//       <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//         {t("reports.weekNote")}
//       </Typography>

//       <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom color="primary">
//               {t("Issues statistics per Room per week")}
//             </Typography>
//             <TextField
//               type="date"
//               value={week}
//               onChange={handleWeekChange}
//               fullWidth
//               variant="outlined"
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom color="primary">
//               {t("Issues statistics per Room per month")}
//             </Typography>
//             <TextField
//               type="month"
//               value={month}
//               onChange={handleMonthChange}
//               fullWidth
//               variant="outlined"
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom color="primary">
//               {t("Appointment statistics per Room per year")}
//             </Typography>
//             <TextField
//               type="number"
//               value={year}
//               onChange={handleYearChange}
//               fullWidth
//               variant="outlined"
//               InputProps={{
//                 inputProps: { min: 2000, max: 2100 },
//               }}
//               InputLabelProps={{ shrink: true }}
//               error={!!yearError}
//               helperText={yearError}
//             />
//           </Grid>
//           <Grid
//             item
//             xs={12}
//             sx={{ display: "flex", justifyContent: "flex-end" }}
//           >
//             <Button
//               variant="outlined"
//               color="secondary"
//               onClick={handleClearFilters}
//               sx={{ mt: 2 }}
//             >
//               {t("Clear Filters")}
//             </Button>
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Issues Stats Chart */}
//       <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
//         {data && data.length > 0 ? (
//           /* ✅ Key forces Recharts to refresh completely when filters change */
//           <ResponsiveContainer width="100%" height={400} key={`${month}-${year}-${week}`}>
//             <BarChart
//               data={data}
//               margin={{ top: 5, right: 30, left: 20, bottom: 25 }}
//             >
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis
//                 dataKey="name"
//                 label={{
//                   value: t("Room Number"),
//                   position: "insideBottom",
//                   offset: -10,
//                 }}
//               />
//               <YAxis
//                 label={{
//                   value: t("Total Issues"),
//                   angle: -90,
//                   position: "insideLeft",
//                 }}
//               />
//               <Tooltip />
//               <Legend verticalAlign="top" height={36}/>
//               <Bar dataKey="total" fill="#8884d8" name={t("Issues")} barSize={50} />
//             </BarChart>
//           </ResponsiveContainer>
//         ) : (
//           <Box sx={{ py: 10, textAlign: 'center' }}>
//             <Typography variant="h6" color="text.secondary">
//               {t("No data found for this period")}
//             </Typography>
//           </Box>
//         )}
//       </Paper>
//     </Box>
//   );
// };

// export default AssignedClientStats;


// import { useState, useEffect, useCallback } from "react";
// import axiosClient from "../axiosClient";
// import {
//   BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
// } from "recharts";
// import { useStateContext } from "../context/ContextProvider";
// import { useTranslation } from "react-i18next";
// import { Grid, TextField, Typography, Box, Paper, Button } from "@mui/material";

// const AssignedClientStats = () => {
//   const [data, setData] = useState([]);
//   const [month, setMonth] = useState("");
//   const [year, setYear] = useState("");
//   const [week, setWeek] = useState("");
//   const [yearError, setYearError] = useState("");
//   const { user } = useStateContext();
//   const { t } = useTranslation();

//   const getMondayOfWeek = (dateString) => {
//     const date = new Date(dateString);
//     const day = date.getDay();
//     const diff = day === 0 ? -6 : -day + 1;
//     date.setDate(date.getDate() + diff);
//     return date.toISOString().split("T")[0];
//   };

//   const validateYear = useCallback((year) => {
//     if (!year) return true;
//     const yearNum = parseInt(year, 10);
//     if (isNaN(yearNum) || yearNum < 2000 || yearNum > 2100) {
//       setYearError(t("reports.yearValidationError"));
//       return false;
//     }
//     setYearError("");
//     return true;
//   }, [t]);

//   const { token } = user;

//   // ✅ 1. Aggressive Fetch: Clears data the moment it's called
//   // const fetchData = useCallback((url) => {
//   //   setData([]); // Kill the old data immediately

//   //   axiosClient
//   //     .get(url, {
//   //       headers: { Authorization: `Bearer ${token}` },
//   //     })
//   //     .then((response) => {
//   //       if (response.data && Array.isArray(response.data) && response.data.length > 0) {
//   //         setData(response.data);
//   //       } else {
//   //         setData([]); // Ensure it stays empty if API returns nothing
//   //       }
//   //     })
//   //     .catch((error) => {
//   //       console.error("Error fetching data:", error);
//   //       setData([]); 
//   //     });
//   // }, [token]);
//    // 1. THIS IS THE REMOVER
//   const fetchData = useCallback((url) => {
//     // FORCE REMOVAL: This line makes the graph disappear 
//     // the millisecond the network request starts.
//     setData([]); 

//     axiosClient
//       .get(url, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         // OVERWRITE: We use setData(response.data), NOT [...data, ...response.data]
//         // This ensures the old data is GONE.
//         if (response.data && Array.isArray(response.data) && response.data.length > 0) {
//           setData(response.data);
//         } else {
//           // If no data, keep it empty to show "No Data Found" message
//           setData([]); 
//         }
//       })
//       .catch((error) => {
//         console.error("Error:", error);
//         setData([]); // Clear on error too
//       });
//   }, [token]);

//   // 2. THE TRIGGER RESET
//   const handleMonthChange = (e) => {
//     const newValue = e.target.value;
    
//     // TRIPLE CHECK RESET: Clear everything before updating state
//     setData([]); 
//     setMonth(newValue);
//     setYear("");
//     setWeek("");
//   };

//   // ✅ 2. Merged & Fixed Month Effect
//   useEffect(() => {
//     if (month) {
//       const [y, mon] = month.split("-");
//       // Use mon as is (e.g. "04") for standard Django URL patterns
//       fetchData(`assignedClientStats/month/${mon}-${y}/`);
//     }
//   }, [month, fetchData]);

//   useEffect(() => {
//     if (year && validateYear(year)) {
//       fetchData(`assignedClientStats/year/${year}/`);
//     }
//   }, [year, fetchData, validateYear]);

//   useEffect(() => {
//     if (week) {
//       fetchData(`assignedClientStats/week/${week}/`);
//     }
//   }, [week, fetchData]);

//   // ✅ 3. Input Handlers that clear data first
//   const handleMonthChange = (e) => {
//     setData([]); 
//     setMonth(e.target.value);
//     setYear("");
//     setWeek("");
//   };

//   const handleYearChange = (e) => {
//     const value = e.target.value;
//     setData([]); 
//     setYear(value);
//     setMonth("");
//     setWeek("");
//     validateYear(value);
//   };

//   const handleWeekChange = (e) => {
//     const selectedDate = e.target.value;
//     setData([]); 
//     if (selectedDate) {
//       setWeek(getMondayOfWeek(selectedDate));
//     } else {
//       setWeek("");
//     }
//     setMonth("");
//     setYear("");
//   };

//   const handleClearFilters = () => {
//     setMonth("");
//     setYear("");
//     setWeek("");
//     setYearError("");
//     setData([]);
//   };

//   return (
//     <Box sx={{ p: { xs: 2, md: 4 } }}>
//       <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//         {t("reports.weekNote")}
//       </Typography>

//       <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom color="primary">Weekly Stats</Typography>
//             <TextField
//               type="date"
//               value={week}
//               onChange={handleWeekChange}
//               fullWidth
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom color="primary">Monthly Stats</Typography>
//             <TextField
//               type="month"
//               value={month}
//               onChange={handleMonthChange}
//               fullWidth
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom color="primary">Yearly Stats</Typography>
//             <TextField
//               type="number"
//               value={year}
//               onChange={handleYearChange}
//               fullWidth
//               error={!!yearError}
//               helperText={yearError}
//             />
//           </Grid>
//           <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
//             <Button variant="outlined" color="secondary" onClick={handleClearFilters}>
//               {t("Clear Filters")}
//             </Button>
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Issues Stats Chart */}
//       <Paper elevation={3} sx={{ p: 3, mb: 4, minHeight: 450 }}>
//         {data && data.length > 0 ? (
//           /* ✅ Key ensures the component is RE-MOUNTED every time the selection changes */
//           <ResponsiveContainer width="100%" height={400} key={month || year || week || "empty"}>
//             <BarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 25 }}>
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis dataKey="name" />
//               <YAxis />
//               <Tooltip />
//               <Legend verticalAlign="top" height={36}/>
//               <Bar dataKey="total" fill="#8884d8" name={t("Issues")} barSize={50} />
//             </BarChart>
//           </ResponsiveContainer>
//         ) : (
//           <Box sx={{ py: 15, textAlign: 'center' }}>
//             <Typography variant="h6" color="text.secondary">
//               {t("No data found for this period")}
//             </Typography>
//           </Box>
//         )}
//       </Paper>
//     </Box>
//   );
// };

// export default AssignedClientStats;

// import { useState, useEffect, useCallback } from "react";
// import axiosClient from "../axiosClient";
// import {
//   BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
// } from "recharts";
// import { useStateContext } from "../context/ContextProvider";
// import { useTranslation } from "react-i18next";
// import { Grid, TextField, Typography, Box, Paper, Button } from "@mui/material";

// const AssignedClientStats = () => {
//   const [data, setData] = useState([]);
//   const [month, setMonth] = useState("");
//   const [year, setYear] = useState("");
//   const [week, setWeek] = useState("");
//   const [yearError, setYearError] = useState("");
//   const { user } = useStateContext();
//   const { t } = useTranslation();
//   const { token } = user;

//   const getMondayOfWeek = (dateString) => {
//     const date = new Date(dateString);
//     const day = date.getDay();
//     const diff = day === 0 ? -6 : -day + 1;
//     date.setDate(date.getDate() + diff);
//     return date.toISOString().split("T")[0];
//   };

//   const validateYear = useCallback((year) => {
//     if (!year) return true;
//     const yearNum = parseInt(year, 10);
//     if (isNaN(yearNum) || yearNum < 2000 || yearNum > 2100) {
//       setYearError(t("reports.yearValidationError"));
//       return false;
//     }
//     setYearError("");
//     return true;
//   }, [t]);

//   // ✅ 1. SINGLE CLEAN FETCH DATA FUNCTION
//   const fetchData = useCallback((url) => {
//     setData([]); // REMOVE OLD GRAPH IMMEDIATELY

//     axiosClient
//       .get(url, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         if (response.data && Array.isArray(response.data) && response.data.length > 0) {
//           setData(response.data); // Replace with new data
//         } else {
//           setData([]); // No data found
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching data:", error);
//         setData([]); 
//       });
//   }, [token]);

//   // ✅ 2. CLEAN EFFECTS (One per filter)
//   useEffect(() => {
//     if (month) {
//       const [y, mon] = month.split("-");
//       fetchData(`assignedClientStats/month/${mon}-${y}/`);
//     }
//   }, [month, fetchData]);

//   useEffect(() => {
//     if (year && validateYear(year)) {
//       fetchData(`assignedClientStats/year/${year}/`);
//     }
//   }, [year, fetchData, validateYear]);

//   useEffect(() => {
//     if (week) {
//       fetchData(`assignedClientStats/week/${week}/`);
//     }
//   }, [week, fetchData]);

//   // ✅ 3. CLEAN HANDLERS (Clears data first)
//   const handleMonthChange = (e) => {
//     setData([]); 
//     setMonth(e.target.value);
//     setYear("");
//     setWeek("");
//   };

//   const handleYearChange = (e) => {
//     const value = e.target.value;
//     setData([]); 
//     setYear(value);
//     setMonth("");
//     setWeek("");
//     validateYear(value);
//   };

//   const handleWeekChange = (e) => {
//     const selectedDate = e.target.value;
//     setData([]); 
//     if (selectedDate) {
//       setWeek(getMondayOfWeek(selectedDate));
//     } else {
//       setWeek("");
//     }
//     setMonth("");
//     setYear("");
//   };

//   const handleClearFilters = () => {
//     setMonth("");
//     setYear("");
//     setWeek("");
//     setYearError("");
//     setData([]);
//   };

//   return (
//     <Box sx={{ p: { xs: 2, md: 4 } }}>
//       <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//         {t("reports.weekNote")}
//       </Typography>

//       <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom color="primary">
//               {t("Issues statistics per Room per week")}
//             </Typography>
//             <TextField
//               type="date"
//               value={week}
//               onChange={handleWeekChange}
//               fullWidth
//               variant="outlined"
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom color="primary">
//               {t("Issues statistics per Room per month")}
//             </Typography>
//             <TextField
//               type="month"
//               value={month}
//               onChange={handleMonthChange}
//               fullWidth
//               variant="outlined"
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom color="primary">
//               {t("Issues statistics per Room per year")}
//             </Typography>
//             <TextField
//               type="number"
//               value={year}
//               onChange={handleYearChange}
//               fullWidth
//               variant="outlined"
//               InputLabelProps={{ shrink: true }}
//               error={!!yearError}
//               helperText={yearError}
//             />

//           </Grid>
//           <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
//             <Button variant="outlined" color="secondary" onClick={handleClearFilters}>
//               {t("Clear Filters")}
//             </Button>
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Issues Stats Chart */}
//       <Paper elevation={3} sx={{ p: 3, mb: 4, minHeight: 450 }}>
//         {data && data.length > 0 ? (
//           <ResponsiveContainer width="100%" height={400} key={`${month}-${year}-${week}`}>
//             <BarChart
//               data={data}
//               margin={{ top: 5, right: 30, left: 20, bottom: 25 }}
//             >
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis dataKey="name" />
//               <YAxis />
//               <Tooltip />
//               <Legend verticalAlign="top" height={36}/>
//               <Bar dataKey="total" fill="#8884d8" name={t("Issues")} barSize={50} />
//             </BarChart>
//           </ResponsiveContainer>
//         ) : (
//           <Box sx={{ py: 15, textAlign: 'center' }}>
//             <Typography variant="h6" color="text.secondary">
//               {t("No data found for this period")}
//             </Typography>
//           </Box>
//         )}
//       </Paper>
//     </Box>
//   );
// };

// export default AssignedClientStats;



import { useState, useEffect, useCallback } from "react";
import axiosClient from "../axiosClient";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from "recharts";
import { useStateContext } from "../context/ContextProvider";
import { useTranslation } from "react-i18next";
import { Grid, TextField, Typography, Box, Paper, Button } from "@mui/material";

const AssignedClientStats = () => {
  const [data, setData] = useState([]);
  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [yearError, setYearError] = useState("");
  const { user } = useStateContext();
  const { t } = useTranslation();
  const { token } = user;

  const validateYear = useCallback((year) => {
    if (!year) return true;
    const yearNum = parseInt(year, 10);
    if (isNaN(yearNum) || yearNum < 2000 || yearNum > 2100) {
      setYearError(t("reports.yearValidationError"));
      return false;
    }
    setYearError("");
    return true;
  }, [t]);

  const fetchData = useCallback((url) => {
    setData([]);
    axiosClient
      .get(url, { headers: { Authorization: `Bearer ${token}` } })
      .then((response) => {
        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
          setData(response.data);
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setData([]);
      });
  }, [token]);

  // Day effect
  useEffect(() => {
    if (day) {
      const date = new Date(day);
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const yyyy = date.getFullYear();
      fetchData(`assignedClientStats/day/${dd}-${mm}-${yyyy}/`);
    }
  }, [day, fetchData]);

  // Month effect
  useEffect(() => {
    if (month) {
      const [y, mon] = month.split("-");
      fetchData(`assignedClientStats/month/${mon}-${y}/`);
    }
  }, [month, fetchData]);

  // Year effect
  useEffect(() => {
    if (year && validateYear(year)) {
      fetchData(`assignedClientStats/year/${year}/`);
    }
  }, [year, fetchData, validateYear]);

  const handleDayChange = (e) => {
    setData([]);
    setDay(e.target.value);
    setMonth("");
    setYear("");
  };

  const handleMonthChange = (e) => {
    setData([]);
    setMonth(e.target.value);
    setDay("");
    setYear("");
  };

  const handleYearChange = (e) => {
    const value = e.target.value;
    setData([]);
    setYear(value);
    setDay("");
    setMonth("");
    validateYear(value);
  };

  const handleClearFilters = () => {
    setDay("");
    setMonth("");
    setYear("");
    setYearError("");
    setData([]);
  };

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
        <Grid container spacing={6}>

          {/* DAY */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom color="primary">
              {t("Issues statistics per Room per day")}
            </Typography>
            <TextField
              type="date"
              value={day}
              onChange={handleDayChange}
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          {/* MONTH */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom color="primary">
              {t("Issues statistics per Room per month")}
            </Typography>
            <TextField
              type="month"
              value={month}
              onChange={handleMonthChange}
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          {/* YEAR */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom color="primary">
              {t("Issues statistics per Room per year")}
            </Typography>
            <TextField
              type="number"
              value={year}
              onChange={handleYearChange}
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              error={!!yearError}
              helperText={yearError}
            />
          </Grid>

          <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button variant="outlined" color="secondary" onClick={handleClearFilters}>
              {t("Clear Filters")}
            </Button>
          </Grid>

        </Grid>
      </Paper>

      {/* Chart */}
      <Paper elevation={3} sx={{ p: 3, mb: 4, minHeight: 450 }}>
        {data && data.length > 0 ? (
          <ResponsiveContainer width="100%" height={400} key={`${day}-${month}-${year}`}>
            <BarChart
              data={data}
              margin={{ top: 5, right: 30, left: 20, bottom: 25 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend verticalAlign="top" height={36} />
              <Bar dataKey="total" fill="#8884d8" name={t("Issues")} barSize={50} />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <Box sx={{ py: 15, textAlign: 'center' }}>
            <Typography variant="h6" color="text.secondary">
              {t("No data found for this period")}
            </Typography>
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default AssignedClientStats;